module.exports = __webpack_public_path__ + "img/speaker-RachelRamsey-imgs.ab95a10d.png";